// Copyright 2022
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/speech/v1/speech.proto (package msh.trait.speech.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message msh.trait.speech.v1.SpeechTrait
 */
export const SpeechTrait = proto3.makeMessageType(
  "msh.trait.speech.v1.SpeechTrait",
  [],
);

/**
 * ----------- Commands ----------- //
 *
 * @generated from message msh.trait.speech.v1.SpeechTrait.TextToSpeechCommand
 */
export const SpeechTrait_TextToSpeechCommand = proto3.makeMessageType(
  "msh.trait.speech.v1.SpeechTrait.TextToSpeechCommand",
  () => [
    { no: 1, name: "speech", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "voice_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "fall_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SpeechTrait_TextToSpeechCommand"},
);

/**
 * ----------- Events ----------- //
 *
 * @generated from message msh.trait.speech.v1.SpeechTrait.SpeechTranscriptEvent
 */
export const SpeechTrait_SpeechTranscriptEvent = proto3.makeMessageType(
  "msh.trait.speech.v1.SpeechTrait.SpeechTranscriptEvent",
  () => [
    { no: 1, name: "transcript", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confidence", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "fall_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "SpeechTrait_SpeechTranscriptEvent"},
);

